// extracted by mini-css-extract-plugin
export default {"container":"BannerConfigForm_container__u9fPV"};